import { type AxiosInstance } from "axios";
import type { UpdateRegistryChangeAlertStateAPIRequest } from "@/features/registryChangeAlert/types";

/**
 * 変動アラートの既読・非表示を更新する。
 * 共有範囲で同じ物件のアラートはまとめて更新される（BE 側で処理）。
 * @param {AxiosInstance} apiClient JWT 認証付き apiClient
 * @param {number} id アラート ID
 * @param {UpdateRegistryChangeAlertStateAPIRequest} request 更新内容
 */
export const UpdateRegistryChangeAlertStateAPI = async (
  apiClient: AxiosInstance,
  id: number,
  request: UpdateRegistryChangeAlertStateAPIRequest
): Promise<void> => {
  await apiClient.patch(`/registry-change-alerts/${id}`, request);
};
